/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createOurValuesSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      width: '100vw',
      backgroundColor: '#F6F7F8',
      padding: 'calc(100% * (100 / 1440)) calc(100% * (150 / 1440))',
      overflow: 'hidden',
    },
    container: {
      maxWidth: '1140px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    plxServicesBlock: {
      width: '100%',
    },
    title: {
      width: '100%',
      textAlign: 'center',
      marginBottom: '100px',
    },
    plxServicesCard: {
      height: '100%',
    },
    card: {
      borderRadius: '8px',
      border: '1px solid #EEEEEE',
      padding: '30px 32px 40px',
      display: 'inline-flex',
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      textDecoration: 'none',
    },
    cardTitle: {
      fontSize: '24px',
      lineHeight: '40px',
      marginBottom: '20px',
    },
    cardText: {
      textAlign: 'center',
      letterSpacing: 'normal',
      '& > i': {
        textDecoration: 'underline',
        fontStyle: 'none',
        color: theme.palette.secondary.main,
      },
    },
  }),
);

export { createOurValuesSectionStyles };
